// Libs
import React, { Component } from 'react'
import { Carousel } from 'react-bootstrap'

// Styles
import './Content.css'

// Images
import carousel from '../../img/carousel.png'


class Content extends Component  {

  constructor(props) {
    super(props)
    this.state = {
    }
  }


  render() {
    return (
      <div className="carousel-container">
        <Carousel className="carousel-slide" activeIndex={this.props.carousel.index} direction={this.props.carousel.direction} onSelect={this.props.handleCarousel}>
          <Carousel.Item>
            <img width={900} height={1200} alt="900x500" src={carousel}/>
            <Carousel.Caption className="text-content">
              <h3>{this.props.data[0].content.heading}</h3>
              <p>{this.props.data[0].content.text}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width={900} height={1200} alt="900x500" src={carousel}/>
            <Carousel.Caption className="text-content">
              <h3>{this.props.data[1].content.heading}</h3>
              <h5>{this.props.data[1].content.subheading}</h5>
              <p>{this.props.data[1].content.text}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width={900} height={1200} alt="900x500" src={carousel}/>
            <Carousel.Caption className="text-content">
              <h3>{this.props.data[2].content.heading}</h3>
              <h5>{this.props.data[2].content.subheading}</h5>
              <p>{this.props.data[2].content.text}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width={900} height={1200} alt="900x500" src={carousel}/>
            <Carousel.Caption className="text-content">
              <h3>{this.props.data[3].content.heading}</h3>
              <h5>{this.props.data[3].content.subheading}</h5>
              <p>{this.props.data[3].content.text}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width={900} height={1200} alt="900x500" src={carousel}/>
            <Carousel.Caption className="text-content">
              <h3>{this.props.data[4].content.heading}</h3>
              <h5>{this.props.data[4].content.subheading}</h5>
              <p>{this.props.data[4].content.text}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width={900} height={1200} alt="900x500" src={carousel}/>
            <Carousel.Caption className="text-content">
              <h3>{this.props.data[5].content.heading}</h3>
              <h5>{this.props.data[5].content.subheading}</h5>
              <p>{this.props.data[5].content.text}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width={900} height={1200} alt="900x500" src={carousel}/>
            <Carousel.Caption className="text-content">
              <h3>{this.props.data[6].content.heading}</h3>
              <h5>{this.props.data[6].content.subheading}</h5>
              <p>{this.props.data[6].content.text}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width={900} height={1200} alt="900x500" src={carousel}/>
            <Carousel.Caption className="text-content">
              <h3>{this.props.data[7].content.heading}</h3>
              <h5>{this.props.data[7].content.subheading}</h5>
              <p>{this.props.data[7].content.text}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width={900} height={1200} alt="900x500" src={carousel}/>
            <Carousel.Caption className="text-content">
              <h3>{this.props.data[8].content.heading}</h3>
              <h5>{this.props.data[8].content.subheading}</h5>
              <p>{this.props.data[8].content.text}</p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </div>
    )
  }

}

export default Content;



/** WEBPACK FOOTER **
 ** ./src/components/pages/Content.js
 **/